// extracted by mini-css-extract-plugin
export default {"button":"Butoon_button__8fPAv"};